
const routes = {
  LandingPage: "/",
  UpcomingTraining: "/upcoming-training",
  TrackApplication: "/application",
  TrainingCenters: "/training-centers",
  TrainingCalendar: "/training-calendar",
  FAQ: "/FAQ",
  HomeHelpdesk: "/helpdesk",
  HelpdeskNewRequest: "/helpdesk/new-request",
  HelpdeskTrackRequest: "/helpdesk/track-request",
  PaymentGuidelines: "/helpdesk/payment-guidelines",
  DashboardAnnouncements: "/dashboard-announcements",
  PreRegistration: "/pre-registration",
  Registration: "/registration",
  ResetPassword: "/reset-password/:resetId",
  VerifyEmail: "/verify-email",
  PendingVerification: "/pre-registration/pending-verification",
  Login: "/login",
  ForgotPassword: "/forgot-password",
  Dashboard: "/trainee/dashboard",
  Courses: "/trainee/courses",
  FundWallet: "/trainee/fund-wallet",
  WalletHistory: "/trainee/wallet-history",
  trainerPreReg: "/trainer-pre-registration",
  successfulPayment: "/trainee/payment/successful",
  successfulEnrolment: "/trainee/enrollment/successful",
  successfulDeferment: "/trainee/deferment/successful",
  successfulPaymentWallet: "/trainee/payment/successful-fund",
  PaymentPath: "/trainee/payment/:course_id/course/:enrolment_id/enrolments",
  PaymentLink: (course_id: string, enrolment_id: string) =>
    `/trainee/payment/${course_id}/course/${enrolment_id}/enrolments`,
  Result: "/trainee/result",
  Survey: "/trainee/survey/:course_id/:survey_uuid",
  SurveyLink: (course_id: string, survey_uuid: string) =>
    `/trainee/survey/${course_id}/${survey_uuid}`,
  SurveyEntry: "/trainee/survey/:course_id/view-surveys",
  SurveyEntryLink: (course_id: string) =>
    `/trainee/survey/${course_id}/view-surveys`,
  Application: "/trainee/my-applications",
  Flyer: "/flyer",
  AnnouncementDetail: "/announcement-detail/:announcement_id",
  ViewAnnouncementLink: (announcement_id: string) => `/announcement-detail/${announcement_id}`,
};

export default routes;
